import './storemap.less';

export const prefix = 'bm-p-store-map';

export { default } from './StoreMapPage';
